/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminWorkspace } from '../models/AdminWorkspace';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminService {
    /**
     * 200 if the caller is an admin, else 403
     * @returns any The caller is an admin
     * @throws ApiError
     */
    public static getAdminMe(): CancelablePromise<{
        data?: {
            admin?: boolean;
            user_id?: string;
        };
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/me',
            errors: {
                403: `Not an admin`,
            },
        });
    }
    /**
     * Every workspace, deleted ones included, with billing and members
     * @returns any All workspaces
     * @throws ApiError
     */
    public static getAdminWorkspaces(): CancelablePromise<{
        data?: Array<AdminWorkspace>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/workspaces',
        });
    }
    /**
     * Soft-delete a workspace, as its owner would
     * @param id
     * @returns any Deleted
     * @throws ApiError
     */
    public static deleteAdminWorkspace(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/workspaces/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `No such workspace`,
                409: `Already deleted`,
            },
        });
    }
    /**
     * Undo a soft delete
     * @param id
     * @returns any Restored
     * @throws ApiError
     */
    public static postAdminWorkspaceRestore(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/workspaces/{id}/restore',
            path: {
                'id': id,
            },
            errors: {
                404: `No such workspace`,
                409: `Not deleted`,
            },
        });
    }
    /**
     * Join the workspace as owner
     * @param id
     * @returns any Joined, or already a member
     * @throws ApiError
     */
    public static postAdminWorkspaceJoin(
        id: string,
    ): CancelablePromise<{
        data?: {
            joined?: boolean;
            role?: string;
        };
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/workspaces/{id}/members/me',
            path: {
                'id': id,
            },
            errors: {
                404: `No such workspace`,
            },
        });
    }
    /**
     * Leave the workspace
     * @param id
     * @returns any Left, or was not a member
     * @throws ApiError
     */
    public static deleteAdminWorkspaceLeave(
        id: string,
    ): CancelablePromise<{
        data?: {
            left?: boolean;
        };
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/workspaces/{id}/members/me',
            path: {
                'id': id,
            },
            errors: {
                404: `No such workspace`,
            },
        });
    }
}
